import { useEffect } from "react";
import { useCookieConsent } from "@/hooks/useCookieConsent";

const GA_ID = "G-K34N9Z0VK9";
const GA_DISABLE_KEY = `ga-disable-${GA_ID}`;

function enableGA() {
  (window as any)[GA_DISABLE_KEY] = false;
  // Send a fresh pageview now that tracking is enabled
  if (typeof (window as any).gtag === "function") {
    (window as any).gtag("config", GA_ID, { page_path: window.location.pathname });
  }
}

function disableGA() {
  (window as any)[GA_DISABLE_KEY] = true;

  // Remove GA cookies
  document.cookie.split(";").forEach((c) => {
    const name = c.trim().split("=")[0];
    if (name.startsWith("_ga")) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  });
}

export default function GoogleAnalytics() {
  const { areCookiesAllowed } = useCookieConsent();

  useEffect(() => {
    // Initial check
    if (areCookiesAllowed()) {
      enableGA();
    } else {
      disableGA();
    }

    // Listen for consent changes
    const handler = (e: Event) => {
      const { accepted } = (e as CustomEvent).detail;
      if (accepted) {
        enableGA();
      } else {
        disableGA();
      }
    };

    window.addEventListener("cookieConsentChanged", handler);
    return () => window.removeEventListener("cookieConsentChanged", handler);
  }, [areCookiesAllowed]);

  return null;
}
